import { render } from "./DoubleAntenna.vue?vue&type=template&id=365a13c3&scoped=true"
import script from "./DoubleAntenna.vue?vue&type=script&lang=js"
export * from "./DoubleAntenna.vue?vue&type=script&lang=js"

import "./DoubleAntenna.vue?vue&type=style&index=0&id=365a13c3&scoped=true&lang=css"

import exportComponent from "D:\\dev_workspace\\cy\\web\\linkomweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365a13c3"]])

export default __exports__